import React, { createContext, useContext, useState, useEffect } from "react";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const savedFavorites = localStorage.getItem("expertPlatformFavorites");
    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }
  }, []);

  const addFavorite = (expertId) => {
    const updated = [...favorites, expertId];
    setFavorites(updated);
    localStorage.setItem("expertPlatformFavorites", JSON.stringify(updated));
  };

  const removeFavorite = (expertId) => {
    const updated = favorites.filter(id => id !== expertId);
    setFavorites(updated);
    localStorage.setItem("expertPlatformFavorites", JSON.stringify(updated));
  };

  const isFavorite = (expertId) => favorites.includes(expertId);

  const toggleFavorite = (expertId) => {
    if (isFavorite(expertId)) {
      removeFavorite(expertId);
    } else {
      addFavorite(expertId);
    }
  };

  return (
    <FavoritesContext.Provider value={{ favorites, addFavorite, removeFavorite, isFavorite, toggleFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error("useFavorites must be used within a FavoritesProvider");
  }
  return context;
}
